"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var use_ssr_1 = __importDefault(require("use-ssr"));
var types_1 = require("./types");
var useFetchArgs_1 = __importDefault(require("./useFetchArgs"));
var doFetchArgs_1 = __importDefault(require("./doFetchArgs"));
var utils_1 = require("./utils");
var CACHE_FIRST = types_1.CachePolicies.CACHE_FIRST;
var cache = new Map();
function useFetch() {
    var _this = this;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a = useFetchArgs_1.default.apply(void 0, args), customOptions = _a.customOptions, requestInit = _a.requestInit, defaults = _a.defaults, dependencies = _a.dependencies;
    var initialURL = customOptions.url, path = customOptions.path, interceptors = customOptions.interceptors, timeout = customOptions.timeout, retries = customOptions.retries, onTimeout = customOptions.onTimeout, onAbort = customOptions.onAbort, onNewData = customOptions.onNewData, perPage = customOptions.perPage, cachePolicy = customOptions.cachePolicy, // 'cache-first' by default
    cacheLife = customOptions.cacheLife;
    var isServer = use_ssr_1.default().isServer;
    var controller = react_1.useRef();
    var res = react_1.useRef({});
    var data = react_1.useRef(defaults.data);
    var timedout = react_1.useRef(false);
    var attempts = react_1.useRef(retries);
    var error = react_1.useRef();
    var hasMore = react_1.useRef(true);
    var _b = react_1.useState(defaults.loading), loading = _b[0], setLoading = _b[1];
    var makeFetch = react_1.useCallback(function (method) {
        var doFetch = function (routeOrBody, body) { return __awaiter(_this, void 0, void 0, function () {
            var theController, _a, url, options, response, _b, err_1, timer, newData, newRes, err_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (isServer)
                            return [2 /*return*/]; // for now, we don't do anything on the server
                        controller.current = new AbortController();
                        controller.current.signal.onabort = onAbort;
                        theController = controller.current;
                        return [4 /*yield*/, doFetchArgs_1.default(requestInit, initialURL, path, method, theController, cachePolicy, cacheLife, cache, routeOrBody, body, interceptors.request)];
                    case 1:
                        _a = _c.sent(), url = _a.url, options = _a.options, response = _a.response;
                        if (!(response.isCached && cachePolicy === CACHE_FIRST)) return [3 /*break*/, 5];
                        setLoading(true);
                        if (!response.isExpired) return [3 /*break*/, 2];
                        cache.delete(response.id);
                        cache.delete(response.ageID);
                        return [3 /*break*/, 5];
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        _b = res.current;
                        return [4 /*yield*/, utils_1.tryGetData(response.cached, defaults.data)];
                    case 3:
                        _b.data = _c.sent();
                        data.current = res.current.data;
                        setLoading(false);
                        return [2 /*return*/, data.current];
                    case 4:
                        err_1 = _c.sent();
                        error.current = err_1;
                        setLoading(false);
                        return [3 /*break*/, 5];
                    case 5:
                        // don't perform the request if there is no more data to fetch (pagination)
                        if (perPage > 0 && !hasMore.current && !error.current)
                            return [2 /*return*/, data.current];
                        setLoading(true);
                        error.current = undefined;
                        timer = timeout > 0 && setTimeout(function () {
                            timedout.current = true;
                            theController.abort();
                            if (onTimeout)
                                onTimeout();
                        }, timeout);
                        _c.label = 6;
                    case 6:
                        _c.trys.push([6, 9, 10, 11]);
                        return [4 /*yield*/, fetch(url, options)];
                    case 7:
                        newRes = _c.sent();
                        res.current = newRes.clone();
                        if (cachePolicy === CACHE_FIRST) {
                            cache.set(response.id, newRes.clone());
                            if (cacheLife > 0)
                                cache.set(response.ageID, Date.now());
                        }
                        return [4 /*yield*/, utils_1.tryGetData(newRes, defaults.data)];
                    case 8:
                        newData = _c.sent();
                        res.current.data = onNewData(data.current, newData);
                        res.current = interceptors.response ? interceptors.response(res.current) : res.current;
                        utils_1.invariant('data' in res.current, 'You must have `data` field on the Response returned from your `interceptors.response`');
                        data.current = res.current.data;
                        if (Array.isArray(data.current) && !!(data.current.length % perPage))
                            hasMore.current = false;
                        return [3 /*break*/, 11];
                    case 9:
                        err_2 = _c.sent();
                        if (attempts.current > 0)
                            return [2 /*return*/, doFetch(routeOrBody, body)];
                        if (attempts.current < 1 && timedout.current)
                            error.current = { name: 'AbortError', message: 'Timeout Error' };
                        if (err_2.name !== 'AbortError')
                            error.current = err_2;
                        return [3 /*break*/, 11];
                    case 10:
                        if (newRes && !newRes.ok && !error.current)
                            error.current = { name: newRes.status, message: newRes.statusText };
                        if (attempts.current > 0)
                            attempts.current -= 1;
                        timedout.current = false;
                        if (timer)
                            clearTimeout(timer);
                        controller.current = undefined;
                        return [7 /*endfinally*/];
                    case 11:
                        setLoading(false);
                        return [2 /*return*/, data.current];
                }
            });
        }); };
        return doFetch;
    }, [isServer, onAbort, requestInit, initialURL, path, interceptors, cachePolicy, perPage, timeout, cacheLife, onTimeout, defaults.data, onNewData]);
    var post = react_1.useCallback(makeFetch(types_1.HTTPMethod.POST), [makeFetch]);
    var del = react_1.useCallback(makeFetch(types_1.HTTPMethod.DELETE), [makeFetch]);
    var request = {
        get: react_1.useCallback(makeFetch(types_1.HTTPMethod.GET), [makeFetch]),
        post: post,
        patch: react_1.useCallback(makeFetch(types_1.HTTPMethod.PATCH), [makeFetch]),
        put: react_1.useCallback(makeFetch(types_1.HTTPMethod.PUT), [makeFetch]),
        del: del,
        delete: del,
        abort: function () { return controller.current && controller.current.abort(); },
        query: function (query, variables) { return post({ query: query, variables: variables }); },
        mutate: function (mutation, variables) { return post({ mutation: mutation, variables: variables }); },
        loading: loading,
        error: error.current,
        data: data.current
    };
    var response = Object.defineProperties({}, utils_1.responseKeys.reduce(function (acc, field) {
        if (utils_1.responseFields.includes(field)) {
            acc[field] = {
                get: function () {
                    if (field === 'data')
                        return data.current;
                    var clonedResponse = ('clone' in res.current ? res.current.clone() : {});
                    return clonedResponse[field];
                },
                enumerable: true
            };
        }
        else if (utils_1.responseMethods.includes(field)) {
            acc[field] = {
                value: function () {
                    var clonedResponse = ('clone' in res.current ? res.current.clone() : {});
                    return clonedResponse[field]();
                },
                enumerable: true
            };
        }
        return acc;
    }, {}));
    // onMount/onUpdate
    react_1.useEffect(function () {
        if (dependencies && Array.isArray(dependencies)) {
            var methodName = requestInit.method || types_1.HTTPMethod.GET;
            var methodLower = methodName.toLowerCase();
            var req = request[methodLower];
            req();
        }
        // TODO: need [request] in dependency array. Causing infinite loop though.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
    // Cancel any running request when unmounting to avoid updating state after component has unmounted
    // This can happen if a request's promise resolves after component unmounts
    // TODO: should have [request.abort] in dependency array. Causing every request to be aborted though...
    // eslint-disable-next-line react-hooks/exhaustive-deps
    react_1.useEffect(function () { return request.abort; }, []);
    return Object.assign([request, response, loading, error.current], __assign({ request: request, response: response }, request));
}
exports.useFetch = useFetch;
exports.default = useFetch;
//# sourceMappingURL=useFetch.js.map